import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachLogTheoAppPaging(payload) {
  return HTTP({
      url: ENDPOINT.LOG.DANH_SACH_LOG_THEO_APP,
      method: "GET",
      params: payload
  });
}


